import ToolTip, { ToolTipProps } from './ToolTip';

export type { ToolTipProps };
export default ToolTip;
